import veriftReport from "@custom/rtk-apis/report/verifyReport";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const verifyReportSlice = createSlice({
  name: "verifyReportSlice",
  initialState,
  reducers: {
    clearVerifyReports: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(veriftReport.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(veriftReport.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload;
        state.msg = payload.msg;
      })
      .addCase(veriftReport.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default verifyReportSlice.reducer;
export const { clearVerifyReports } = verifyReportSlice.actions;
